/* AMORA redesign: quick add to bag (opens the existing cart drawer) */
(function () {
  if (window.__amoraBound) return;
  window.__amoraBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-am-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var id = button.getAttribute('data-am-add');
    var label = button.getAttribute('data-label') || button.textContent;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    button.disabled = true;
    button.textContent = 'Adding…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        button.textContent = 'Added';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
      })
      .catch(function () {
        button.textContent = 'Try again';
      })
      .finally(function () {
        setTimeout(function () { button.disabled = false; button.textContent = label; }, 1800);
      });
  });
})();
